import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

// Using polling-based approach for message updates instead of WebSockets
// This is more reliable in Kubernetes/proxy environments
export function SocketProvider({ children }) {
  const [isConnected] = useState(true); // Always "connected" with polling
  const { user } = useAuth();

  // Subscribe to new messages with polling
  const subscribeToMessages = useCallback((callback, userId) => {
    if (!user?.id) return () => {};
    
    const pollInterval = setInterval(async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/messages/${userId}`,
          { credentials: 'include' }
        );
        if (response.ok) {
          const messages = await response.json();
          callback(messages);
        }
      } catch (error) {
        // Silent fail for polling
      }
    }, 3000); // Poll every 3 seconds

    return () => clearInterval(pollInterval);
  }, [user?.id]);

  return (
    <SocketContext.Provider value={{ socket: null, isConnected, subscribeToMessages }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
}
